module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('nav', {
    attrs: {
      "epub:type": "toc",
      "id": "toc"
    }
  }, [_c('h1', [_vm._v("Table of Contents")]), _vm._v(" "), _c('ol', [_c('li', [_c('a', {
    attrs: {
      "href": "#/cover",
      "id": "np-0"
    }
  }, [_vm._v("Cover")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/97839897349511",
      "id": "np-1"
    }
  }, [_vm._v("The Valley of the Shadow")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/97839897349512",
      "id": "np-2"
    }
  }, [_vm._v("The Seven Missionaries")])])])]), _vm._v(" "), _c('nav', {
    attrs: {
      "epub:type": "landmarks",
      "hidden": "",
      "id": "landmarks"
    }
  }, [_c('h1', [_vm._v("Landmarks")]), _vm._v(" "), _c('ol', [_c('li', [_c('a', {
    attrs: {
      "epub:type": "cover",
      "href": "#/cover"
    }
  }, [_vm._v("Cover")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-70ac24c1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/toc.vue
// module id = 57
// module chunks = 0